import { render, staticRenderFns } from "./MatchBets.vue?vue&type=template&id=3e7fe88d"
import script from "./MatchBets.vue?vue&type=script&lang=js"
export * from "./MatchBets.vue?vue&type=script&lang=js"
import style0 from "./MatchBets.vue?vue&type=style&index=0&id=3e7fe88d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports